<ng-container *ngIf="showMenu">
  <maced-hot-corner (selectedHotCorner)="getHotCorner($event)"></maced-hot-corner>

  <div class="wrapper" [ngClass]="hotCornerClass">
    <div class="top-header">
      <button (click)="menuOpened = !menuOpened" class="ham-burger-menu-button">
        <span class="ham-burger-menu-button__text">Responsive Menu</span></button>
      <app-header></app-header>
    </div>
    <div class="overlay-menu" (click)="menuOpened = !menuOpened" [class.menu-open]="!menuOpened"></div>
    <aside class="left-menu left-menu--modified" [class.menu-open]="!menuOpened">
      <ul class="list-group u-list-style-none u-display-block u-mb-20" (click)="menuOpened = !menuOpened">
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/accordian">Accordian</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/action-card">Action Card</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/badge">Badge</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/breadcrumbs">Breadcrumbs</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/button" [queryParams]="{ hotCornerClass: hotCornerClass }">Button</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/card" [queryParams]="{ hotCornerClass: hotCornerClass }">Card</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/card-slider">Card Slider</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/carousel-with-slidebar">Carousel With Slidebar</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/checkbox">Checkbox</a>
        </li>
        <li>
          <a class="list-group__link" routerLink="/chip">Chips</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/course-level-content-card">Course Level Content</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/date-input">Date Input</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/dialog">Dialog</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/draggable">Draggable</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/dropdown">Dropdown</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/dropdown-without-label"
            [queryParams]="{ hotCornerClass: hotCornerClass }">
            Dropdown Without Label
          </a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/error-state">Empty / Error State</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/floating-panel">Floating panel (Popover)</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/function-card">Function Card</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/footer" [queryParams]="{ hotCornerClass: hotCornerClass }">Footer</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/formElement" [queryParams]="{ hotCornerClass: hotCornerClass }">
            Forms elements
          </a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/filter-sorting">Filter Toolbar</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/global-header">Global Header</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/GlobalNavigationHeaderComponent">Global Navigation Header</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/player">Glossary Player</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/gradingCard">Grading Card</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/header" [queryParams]="{ hotCornerClass: hotCornerClass }">Header</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/hot-corner">Hot Corner</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/indicator">Indicator</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/icon">Icon</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/Link">Link</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/list">List</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/list-card">List Card</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/loader">Loader</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/modal-footer" [queryParams]="{ hotCornerClass: hotCornerClass }">
            Modal Footer
          </a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/modal-header" [queryParams]="{ hotCornerClass: hotCornerClass }">
            Modal Header
          </a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/multi-select">Multi Select</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/multi-range-slider">Multi Range Slider</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/multi-level-progress">Multi Level Progress Bar</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/navigation-drawer">Navigation Drawer</a>
        </li>
         <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/navigation-drawer-with-sub-child">Navigation Drawer With Sub Child</a>
        </li>        
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/navigation-drawer-SubModules">Navigation Drawer With Submodules</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/navigation-drawer-theme">Navigation Drawer With Theme</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/notification-inline"
            [queryParams]="{ hotCornerClass: hotCornerClass }">Notification Inline (With Accordian)</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/numeric-input">Numeric Input</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/pageHeader">Page Header</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/pagelist">Page List</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/pagination">Pagination</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/progress-bar">Progress Bar</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/progress-card">Progress Card</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/radio">Radio</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/read-aloud">Read Aloud</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/search">Search</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/sidePanel">SidePanel</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/spinner">Spinner</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/summarybar">Summary Bar</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/stepper" [queryParams]="{ hotCornerClass: hotCornerClass }">
            Stepper
          </a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/tab">Tab</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/table">Table</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/text-area">Text Area</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/textEditor" [queryParams]="{ hotCornerClass: hotCornerClass }">Text
            Editor</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/time-input">Time Input</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/toast" [queryParams]="{ hotCornerClass: hotCornerClass }">Toast</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/toggle" [queryParams]="{ hotCornerClass: hotCornerClass }">Toggle</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/tree">Tree</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/tooltip">Tooltip</a>
        </li>
        <li class="list-group__item u-display-block">
          <a class="list-group__link" routerLink="/zoom">Zoom</a>
        </li>
      </ul>
    </aside>
    <div class="content-page">
      <main class="main">
        
      <!-- Start - Theme changes demo switch added and will remove actual function.  -->
      <div class="theme-switch-wrapper">
        <label for="dropdown-theme__switch" class="theme-switch-wrapper__label">Theme</label>
        <select onchange="switchTheme()" id="dropdown-theme__switch" name="dropdown-theme__switch">
          <option value="all-secondary">All Secondary</option>
          <option value="primary-teacher">Primary Teacher</option>
          <option value="primary-student">Primary Student</option>
        </select>
      </div>
        <router-outlet></router-outlet>
      </main>
      <div class="footer-copyright">
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!showMenu">
  <router-outlet></router-outlet>
</ng-container>